export default __webpack_public_path__ + "08e854a03a9f8467b70c2739b866b8cb.wav";